import _ from 'lodash';

export const mapProfileToRegisterFields = (profile) => {
  if (!profile) {
    return null;
  }
  return {
    firstName: _.get(profile, 'firstName', '') || _.get(profile, 'given_name', ''),
    lastName: _.get(profile, 'lastName', '') || _.get(profile, 'family_name', ''),
    phone: _.get(profile, 'phone', ''),
    birthdate: _.get(profile, 'birthdate', ''),
  };
};
